import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {LocalAtm,Money,SyncAlt,LastPage,AllInclusive,Add,MoreVert,Schedule,Block,Edit,Delete,Place,WbIncandescentOutlined,ArrowDropDown,DevicesOtherOutlined,AccountBalanceWalletOutlined,ConfirmationNumberOutlined,Close, Filter,FilterList} from '@material-ui/icons';


import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  LinearProgress,
  FormHelperText,
  CircularProgress,
  Grid,
  Chip,
  Link,
  Slide,
  ButtonGroup
} from "@material-ui/core";

import { withLocalize,Translate } from "react-localize-redux";
import MUIDataTable from "mui-datatables";

import { useSnackbar } from 'notistack';
import { setDayWithOptions } from 'date-fns/fp';

import Format from "date-fns/format";

import UserInfo from "../login_info";

import axios from 'axios';

import {TransportService,ReportingService,FinanceService,formatMoney} from "../../../utils/web_config_2";
import { set } from 'date-fns/esm';


import DateFnsUtils from "@date-io/date-fns";

import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },
  btn:{
    textTransform:"capitalize",
  },
  formTitle:{
    flexGrow:1,
},paper: {
  padding: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  height:120,
  elevation:0
},appBar: {
  position: 'relative',
},title: {
  marginLeft: theme.spacing(2),
  flex: 1,
}
}));




function AgentTransaction() {
  const classes = useStyles1();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();


  const [operatorData, setOperatorData] = useState({});
  const [operatorAgent,setOperatorAgent]=useState({});

  const [overviewMessage,setOverviewMessage]=useState("Loading...");


  // overview  table 


const columns = [
  {
    name: "channel_type",
    label: "Channel Type",
    options: {
     filter: true,
     sort: true,
     customBodyRender: (value, tableMeta, updateValue) => {
      return (<Typography color="primary"><Link href="#" onClick={()=>{
        // setRoute(value);
        // get_details_report(value);
      }}>
        {value}
      </Link>
      </Typography>
      );
   }
    }
   },
  {
   name: "amount",
   label:"Amount",
   options: {
    filter: true,
    sort: true,
    customBodyRender: (value, tableMeta, updateValue) => {
      return(<Typography>{formatMoney(value,0)}</Typography>)
    }
   }
  },
  // {
  //  name: "debited_account_balance",
  //  label: "Debited Account Balance",
  //  options: {
  //   filter: true,
  //   sort: false,
  //   customBodyRender: (value, tableMeta, updateValue) => {
  //     return(<Typography>{formatMoney(value,0)}</Typography>)
  //   }
  //  }
  // },
  {
    name: "account_name",
    label: "Credited Account",
    options: {
     filter: true,
     sort: false,
     customBodyRender: (value, tableMeta, updateValue) => {
      return(<Typography>{value}</Typography>)
    }
    }
   },
  {
   name: "commission_value",
   label: "Commission",
   options: {
    filter: true,
    sort: false,
   }
  }, {
    name: "total_commission_amount",
    label: "Commission Amount",
    options: {
     filter: true,
     sort: true,
     customBodyRender: (value, tableMeta, updateValue) => {
      return(<Typography>{formatMoney(value,0)}</Typography>)
    }
    }
   },
   {
    name: "tx_type_name",
    label: "Transaction Type",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "status",
    label: "Status",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "tx_date",
    label: "Transaction Date",
    options: {
     filter: true,
     sort: true,
    }
   }
 ];



 const options = {
  textLabels: {
    body: {
      noMatch: "No transactions available"
    },
  },
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 10,
   elevation:0
 };





  useEffect(()=>{

    var data = {};
    const data1 = localStorage.getItem("nx_op");
    if (data1 != null) {
      data = JSON.parse(data1);
    }

    setOperatorData(data);
    axios.defaults.baseURL = new TransportService().BASE_URL;

    var operatorAgentProfile=JSON.parse(localStorage.getItem("operatorAgent"));
    console.log("operatorAgent",operatorAgentProfile);

    setOperatorAgent(operatorAgentProfile);

    // getTransactions(data.token,operatorAgentProfile.agent_code);

    getBalance(data.token,new UserInfo().AGENT_CODE);
    // Format(new Date(), ["yyyy-MM-dd",])
    getTransactionHistory(data.token,new UserInfo().AGENT_CODE,Format(new Date(), ["yyyy-MM-dd",]));

  },[]);


  // load balance


  const [agentBalance,setAgentBalance]=useState({});
  const getBalance=(token,agent_code)=>{
    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const reportInstance = axios.create(new FinanceService().setHeaders(token));
    reportInstance.get('/api/v1/getAgentBalance/'+agent_code
    ).then(res=>{
      // console.log("balance",res.data.data);
      setAgentBalance(res.data.data);
    })
    .catch(err=>{

    });
  }


  const [day,setDay]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
  // transaction history

  

  const [filterMode,setFilterMode]=useState("TODAY");


  const [reportLoad,setReportLoad]=useState(false);
  const [reports,setReports]=useState([]);
  

  const getTransactionHistory=(token,agent_code,date)=>{
    setReportLoad(true);
    setReports([]);

    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const reportInstance = axios.create(new FinanceService().setHeaders(token));
    reportInstance.get('/api/v1/getAgentTransactions/' + agent_code + '?start_date=' + date + '&end_date=' + date +'&page=0&per_page=10000'
    ).then(res=>{
      setReportLoad(false);
      console.log("transaction",res.data.data);
      setReports(res.data.data);
    })
    .catch(err=>{
      setReportLoad(false);
    });
  }



  // filter transactions 

  const filterTransactions=(startDate,endDate)=>{
     setReportLoad(true);

    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const reportInstance = axios.create(new FinanceService().setHeaders(operatorData.token));
    reportInstance.get('/api/v1/getAgentTransactions/' + new UserInfo().AGENT_CODE + '?start_date=' + startDate + '&end_date=' + endDate +'&page=0&per_page=10000'
    ).then(res=>{
      setReportLoad(false);
      console.log("transaction",res.data.data);
      setReports(res.data.data);
    })
    .catch(err=>{
      setReportLoad(false);
    });
  }


 



  // format money 

  function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  
      const negativeSign = amount < 0 ? "-" : "";
  
      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;
  
      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  };



  //overview detailed report 

  const [detailsMessage,setDetailsMessage]=useState("loading...")






  

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <div className={classes.root}>
      <Box display="flex" mb={1} >
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}><SyncAlt fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b>Transaction History</b></Typography>

 </Box>
 <Box mt={1} display="flex">
   <Box mt={1} mr={1}>
 <ButtonGroup disableElevation size="medium" color="primary" aria-label="outlined primary button group">
  <Button onClick={()=>{
    setFilterMode("TODAY");
    var d = new Date();
    d.setDate(d.getDate()-1);
    getTransactionHistory(operatorData.token,new UserInfo().AGENT_CODE,Format(d, ["yyyy-MM-dd",]));
    

  }}  variant={filterMode=="TODAY"?"contained":"outlined"}>Today</Button>
  <Button onClick={()=>{
    setFilterMode("WEEK");

    var end_date=new Date();

    var start_date = new Date();
    start_date.setDate(start_date.getDate()-7);

    filterTransactions(Format(start_date, ["yyyy-MM-dd",]),Format(end_date, ["yyyy-MM-dd",]));

  }} variant={filterMode=="WEEK"?"contained":"outlined"}>Week</Button>
  <Button onClick={()=>{
    setFilterMode("MONTH");

    var end_date=new Date();

    var start_date = new Date();
    start_date.setDate(start_date.getDate()-31);

    filterTransactions(Format(start_date, ["yyyy-MM-dd",]),Format(end_date, ["yyyy-MM-dd",]));

  }}  variant={filterMode=="MONTH"?"contained":"outlined"}>Month</Button>
</ButtonGroup>
</Box>
<Box>
<IconButton color="primary" aria-label="upload picture" component="span">
          <FilterList />
        </IconButton>
</Box>
           {/* <DatePicker
                fullWidth
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                autoOk
                size="small"
                label="Filter"
                value={day.value}
                inputVariant="outlined"
                onChange={(v)=>{
                  if(Format(v, ["yyyy-MM-dd",])!=Format(new Date(), ["yyyy-MM-dd",])){
                    setDay({value:Format(v, ["yyyy-MM-dd",]),error:""});
                    setFiltering(true);
                    filter_report(Format(v, ["yyyy-MM-dd",]));
                  }else{
                    setDay({value:Format(v, ["yyyy-MM-dd",]),error:""});
                    setFiltering(false);
                  }
                }}
                InputProps={{
                  disableUnderline: true,
                  style: { paddingRight: 0 },
                }}
              /> */}

            </Box>
 
 {/* <Button m={2} size="small" color="primary" variant="outlined" startIcon={<FilterList />} onClick={()=>{
   setFilterDialog(true);
 }}>
Filter
 </Button> */}

 
     </Box>

<Grid container spacing={1}>

{/* total tickets  */}

     <Grid item xs={12} md={4} >
            <Paper className={classes.paper} elevation={0}>
            <Grid container>
          <Grid item xs={8} md={8}>
            <Box><Typography variant="h7" className={classes.title}>Current Balance</Typography></Box>
  <Box mt={2}><Typography variant="h6" className={classes.title}>{formatMoney(agentBalance.current_balance,0)}</Typography></Box>
           
          </Grid>

          <Grid item xs={4} md={4}>
              <Money style={{width:"80px",height:"80px"}}color="primary"/>
          </Grid>

          </Grid>
          </Paper>
          </Grid>


{/* total amount  */}


<Grid item xs={12} md={4} >
            <Paper className={classes.paper} elevation={0}>
            <Grid container>
          <Grid item xs={8} md={8}>
            <Box><Typography variant="h8" className={classes.title}>Openning Balance</Typography></Box>
  <Box mt={2}><Typography variant="h6" className={classes.title}>{formatMoney(agentBalance.opening_balance,0)} </Typography></Box>
            
          </Grid>
          <Grid item xs={4} md={4}>
            <AccountBalanceWalletOutlined style={{width:"80px",height:"80px"}} color="primary"/>
          </Grid>

          </Grid>
          </Paper>
          </Grid>



          <Grid item xs={12} md={4} >
            <Paper className={classes.paper} elevation={0}>
            <Grid container>
          <Grid item xs={8} md={8}>
            <Box><Typography variant="h8" className={classes.title}>Currency Code</Typography></Box>
            <Box mt={2}><Typography variant="h6" className={classes.title}>{agentBalance.currency_code}</Typography></Box>
          </Grid>
          <Grid item xs={4} md={4}>
            <LocalAtm style={{width:"80px",height:"80px"}} color="primary"/>
          </Grid>

          </Grid>
          </Paper>
          </Grid>


       <Grid item xs={12} sm={12} md={12} lg={12}>
 {/* overview table table  */}

 <Box mt={0}>
 {reportLoad&&<LinearProgress />}
 <MUIDataTable
  title={"Transactions"}
  data={reports}
  columns={columns}
  options={options}
/>
 </Box> 
       </Grid>
     </Grid>


  {/* filter business overview  */}
 

    </div>
    </MuiPickersUtilsProvider>
  );
}

export default  withLocalize(AgentTransaction);